import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button } from '@accure/ui';
import { saveAs } from 'file-saver';
import { Download, Link } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';
import { useAbsoluteUrl } from '@/hooks/useAbsoluteUrl';
import { clipboardWrite } from '@/utils/dom/clipboard-write';

export type DocumentActionsProps = {
  file: File;
};
export function DocumentActions({ file }: DocumentActionsProps) {
  const location = useLocation();
  const url = useAbsoluteUrl({
    pathname: location.pathname,
    search: location.search,
  });

  async function copyToClipboard() {
    await toast.promise(clipboardWrite(url), {
      success: 'URL copied to the clipboard!',
    });
  }

  if (file) {
    return (
      <div className="flex gap-2">
        <Tooltip content="Copy link">
          <Button variant="ghost" onClick={copyToClipboard}>
            <Link />
          </Button>
        </Tooltip>
        <Tooltip content="Download">
          <Button variant="ghost" onClick={() => saveAs(file)}>
            <Download />
          </Button>
        </Tooltip>
      </div>
    );
  }

  return null;
}
